import { Navigate, useSearchParams } from 'react-router-dom';

interface ProtectedDashboardRouteProps {
  children: React.ReactNode;
}

export const ProtectedDashboardRoute = ({ children }: ProtectedDashboardRouteProps) => {
  const [searchParams] = useSearchParams();
  const pwd = searchParams.get('pwd');

  if (pwd !== 'beebacksoon') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
